/** UPLOAD BUTTON
 * + Dropzone
 */

import { useCallback, useState } from "react"
import Dropzone from "react-dropzone"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons"
import Button from "@/components/button"
import { STATUS_LOADED, STATUS_LOADING } from "@/redux/_status.types"
import { withTranslation, WithTranslation } from "react-i18next"
import Space from "@/components/space"
import { toast } from "react-toastify"

interface OwnProps {
  onUpload: Function
  acceptedFiles?: string
  maxSize?: number
  title?: string
  showFrameStyle?: boolean
}

type Props = OwnProps & WithTranslation

function UploadButtonWidget(props: Props) {
  const { t, title, showFrameStyle = false } = props
  const [status, setStatus] = useState<string>(STATUS_LOADED)
  const [acceptedFilesExt] = useState<string>(props.acceptedFiles ? props.acceptedFiles : ".csv,.xls,.xlsx")
  const [maxSize] = useState<number>(props.maxSize ? props.maxSize : 2000000)

  const onDrop = useCallback((acceptedFiles) => {
    uploadFile(acceptedFiles)
  }, [])

  const onDropRejected = useCallback((rejectedFiles) => {
    toast(t(rejectedFiles[0].errors[0].message), { type: "error" })
  }, [])

  async function uploadFile(event) {
    setStatus(STATUS_LOADING)
    await props.onUpload(event)
    setStatus(STATUS_LOADED)
  }

  return (
    <>
      {title && (
        <div className="text-input-title flex">
          <span className="grey-t">{title}</span>
        </div>
      )}

      <Dropzone onDrop={onDrop} onDropRejected={onDropRejected} accept={acceptedFilesExt} maxSize={maxSize}>
        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <div
            className={
              showFrameStyle
                ? `flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-6 transition ${
                    isDragActive ? "border-cyan-500 bg-cyan-50" : "border-gray-300"
                  }`
                : "flex1 flex grey-b upload-button" + (isDragActive ? " upload-button-drop" : "")
            }
            {...getRootProps()}>
            <input {...getInputProps()} />

            {!showFrameStyle && <div className="flex1"></div>}

            <div className="flex1">
              {/* <div className="adm-upload-icon flex"> */}
              <div className={`${showFrameStyle ? "text-3xl text-cyan-500 mb-2 text-center" : "adm-upload-icon flex"}`}>
                <FontAwesomeIcon icon={faCloudUploadAlt}></FontAwesomeIcon>
              </div>

              {isDragActive ? (
                <div style={{ textAlign: "center" }}>
                  <p>{t("file_drop_zone") + ""}</p>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <p className="grey-t">{t("click_or_drop")}</p>
                  {!showFrameStyle && <div className="height-20" />}
                  <div className="flex">
                    <Space />
                    <Button className="primary" isLarge={!showFrameStyle} isLoading={status === STATUS_LOADING}>
                      <input
                        type="file"
                        id="myFile"
                        name="file"
                        multiple={false}
                        onChange={isDragReject ? () => {} : uploadFile}
                        accept={acceptedFilesExt}
                      />
                      {t("adm_upload_btn_action")}
                    </Button>
                    <Space />
                  </div>
                </div>
              )}
            </div>
            {!showFrameStyle && <div className="flex1"></div>}
          </div>
        )}
      </Dropzone>
    </>
  )
}

export default withTranslation()(UploadButtonWidget)
